var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{[_vm.theme]: _vm.theme, 'focus-visible': _vm.showFocus},attrs:{"id":"root"}},[(_vm.ready)?_c(_vm.appComponent,{tag:"component"}):_vm._e(),_vm._v(" "),_c('connection-error',{attrs:{"show":_vm.connectionError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }